import React from "react";
import asset from "assets/images";
import { ReactSVG } from "react-svg";

const TableRowAccordionIcon = ({ accordionState, text, handleClick }) => {
    return (
        <>
            {text && (
                <div className='d-flex'>
                    <div
                        className='accordion__icon'
                        onClick={() => handleClick()}>
                        <ReactSVG
                            src={
                                accordionState
                                    ? asset?.icons?.anchorDown
                                    : asset?.icons?.anchorRight
                            }
                        />
                    </div>
                    <span className='accordion__text'>{text}</span>
                </div>
            )}
        </>
    );
};

export default TableRowAccordionIcon;
